import { Box } from "@mui/material"
import React from "react"

import ObjectAnalysisInfoForm from './ObjectAnalysisInfoForm'
import { GridContainer, GridItem } from "@/ui/Grid";

function ObjectAnalysisInfo (props: any) {
    const { recordId, dc, isDisabled, setNapomenaValue, onSave, submitValue, revisionCounter } = props

    return (
        <Box>
            <GridContainer direction="row">
                {/*<ObjectAnalysisInfoForm
                    dc={dc}
                    recordId={recordId}
                    form='infoDetails'
                    mode='simpleView'
                    columns={2}
                />*/}
                <ObjectAnalysisInfoForm
                    isDisabled={isDisabled}
                    revisionCounter={revisionCounter}
                    setNapomenaValue={setNapomenaValue}
                    onSave={onSave}
                    submitValue={submitValue}
                    dc={dc}
                    recordId={recordId}
                    form='infoForm'
                    mode='update'
                />
            </GridContainer>
        </Box>
    )
}

export default ObjectAnalysisInfo